import styles from "./PageCard.module.css"

export default function PageCard({pageInfo}) {


    return(
        <a className={styles.pageCard} href={pageInfo.link}>
            <h2>{pageInfo.header}</h2>
            {pageInfo.text && <p>{pageInfo.text}</p>}
            {pageInfo.when && <p>{pageInfo.when}</p>}
        </a>
    );
}